import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Observable, fromEvent, merge  } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { debounceTime, distinctUntilChanged, startWith, tap, delay, map } from 'rxjs/operators';
import { forkJoin, BehaviorSubject } from 'rxjs';
import { MultiDropboxComponent, MultiDropboxData, SingleTimePickerComponent } from '../shared';
import { FormControl, FormGroup } from '@angular/forms';
import { SearchFiltersService } from '../search-filters/search-filters.service';
import { Station, RemoteApiService } from '../core';
import * as moment from 'moment';
import { ProfileService } from '../profile/profile.service';
import { ProfileModelService } from '../profile/profile-model.service';

export class SelectValueBindingExample {
  selected = 'option2';
}

export interface Email {
  email: string;
  name: string;
}

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss'],
  providers: [SearchFiltersService]
})
export class SubscriptionsComponent implements OnInit, AfterViewInit {

  @ViewChild('stationMulti',{static: true}) stationMulti: MultiDropboxComponent;
  stations: any;
  origStationsList: Station[];

  myForm: FormGroup;
  selectedDay: string[];
  @ViewChild('emailBox',{static: true}) public emailBox: ElementRef;

  // For Email
  emailCtrl = new FormControl();
  filteredEmails: Observable<Email[]>;
  emails: Email[] = [
    { name: 'Sumathi', email: 'sumaiheart@ihearmedial.com' },
    { name: 'Frank', email: 'frank@iheartmedia.com' },
    { name: 'Neelima', email: 'neelima@iheartmedia.com' },
    { name: 'Steve', email: 'steve@iheartmedia.com' }
  ];

  @ViewChild('startTimePicker',{static: true}) public startTimePicker: SingleTimePickerComponent;
  @ViewChild('endTimePicker',{static: true}) public endTimePicker: SingleTimePickerComponent;

  // Confirmation page
  isConfirmed = false;
  displayedStationName: string;
  displayedWeekDay: string;
  displayedStartTime: string;
  displayedEndTime: string;

  durationBwStartEndInMinutes = '90';

  currentUserEmail = '';
  constructor(
    private profileModelService: ProfileModelService,
    private remoteApi: RemoteApiService,
    private titleService: Title,
    private searchFiltersService: SearchFiltersService,
  ) {
    this.titleService.setTitle('SIA (Search, Index, Archive) - Subscriptions');
    this.myForm = new FormGroup({
      stations: new FormControl(null),
      startTime: new FormControl(null),
      endTime: new FormControl(null)
    });

    /*
    this.filteredEmails = this.emailCtrl.valueChanges
    .pipe(
      startWith(''),
      map(email => email ? this._filterEmails(email) : this.emails.slice())
    );
    */
    this.currentUserEmail = this.profileModelService.getProfile().token;
    setTimeout(() => {
      this.emailCtrl.setValue(this.currentUserEmail);
    }, 1500);
  }

  ngOnInit() {
    this.loadStations();
    this.isConfirmed = false;
  }

  ngAfterViewInit() {
  }

  public loadStations() {
    this.searchFiltersService.loadAllStations().subscribe(stations => {
      this.stationMulti.setList(stations.map((station) => {
        const name: string = station.name || '';
        const frequency: string = station.frequency || '';
        return {
          id: station.id,
          name: `${name} ${frequency}`,
          model: station
        };
      }));
    });
  }

  /*
  private _filterEmails(value: string): Email[] {
    const filterValue = value.toLowerCase();
    return this.emails.filter(email => email.name.toLowerCase().indexOf(filterValue) === 0);
  }
  */

  submit() {
    this.displayedWeekDay = this.selectedDay.join(',');
    this.displayedStationName = this.stations.map(s => s.name);
    this.displayedStartTime = this.myForm.get('startTime').value;
    this.displayedEndTime = this.myForm.get('endTime').value;

    const startTimeStr = moment(this.myForm.get('startTime').value, 'hh:mm:ss A').utc().format('HH:mm:ss');
    const endTimeStr = moment(this.myForm.get('endTime').value, 'hh:mm:ss A').utc().format('HH:mm:ss');

    // Change these properties according to API spec
    this.remoteApi.postSubscription('/emailSubscription', {
      'userId': this.emailCtrl.value,
      'stationId': this.stations.map(s => +s.model.id),
      'startTime': startTimeStr,
      'endTime': endTimeStr,
      'frequencyDay': this.selectedDay
    }).toPromise()
    .then(sub => {
      this.isConfirmed = true;
    })
    .catch(e => {
      console.error('Error occurred:', e);
    });
  }

  clear() {
    this.stations = null;
    this.selectedDay = null;
    this.myForm.reset();
    this.startTimePicker.flatPickerInstance.clear();
    this.endTimePicker.flatPickerInstance.clear();
    this.endTimePicker.flatPickerInstance.set('minTime', null);
    this.endTimePicker.flatPickerInstance.set('maxTime', null);
    this.startTimePicker.flatPickerInstance.set('minTime', null);
    this.startTimePicker.flatPickerInstance.set('maxTime', null);
  }

  get disableSubmitButton() {
    const startTime = moment(this.myForm.get('startTime').value, 'HH:mm:ss A');
    const endTime = moment(this.myForm.get('endTime').value, 'HH:mm:ss A');
    const diff = moment.duration(endTime.diff(startTime));
    const stationsSelected = this.stations && this.stations.length > 0;
    if (stationsSelected
          && this.selectedDay
            && (this.selectedDay.length > 0)
              && this.myForm.get('startTime').value
                && this.myForm.get('endTime').value
                  && endTime.isAfter(startTime)
                    && (diff.asMinutes() <= 90)
                      && this.emailCtrl.valid) {
      return false;
    }
    return true;
  }

  startTimeChanged(startTime) {
    if (startTime) {
      this.endTimePicker.flatPickerInstance.set('minTime', startTime);
      const endTime = moment(startTime, 'HH:mm:ss A').add(this.durationBwStartEndInMinutes, 'minutes').format('HH:mm:ss A');
      const endTimeStr = moment(startTime, 'HH:mm:ss A').add(this.durationBwStartEndInMinutes, 'minutes').format('hh:mm:ss A');
      this.endTimePicker.flatPickerInstance.set('maxTime', endTime);
      this.myForm.controls['endTime'].setValue(endTimeStr);
    }
  }

}
